module.exports = __webpack_public_path__ + "img/160014.02ff3e35.png";